

export enum Currency {
    CHF = "chf",
    EUR = "eur",
}